import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';
import ReactApexChart from 'react-apexcharts';
import { labelStyle, responsiveFun, lgXaxisLabels } from './options';
import trans from '../translations.json';
import ReducedData from '../reducedData.json';
import dict from '../dictionary';
import CasesByAgeTable from './casesByAge-table.jsx';
import { DownloadButton } from './options';
import { ButtonGroup } from './buttonGroup/buttonGroup';
import { ToolTipClone } from './toolTipClone/toolTipClone';
import ApexCharts from 'apexcharts';
import LegandCheckbox from './legandCheckbox/legandCheckbox';

const viewModes = {
  graph: 'graph',
  pie: 'pie',
  table: 'table',
};

const colours = ['#D0908C', '#a5cfa0', '#626262'];
class AgeBreak extends Component {
  state = {
    ageCategories: [
      trans.casesByAge.under20[this.props.lang],
      '20-29',
      '30-39',
      '40-49',
      '50-59',
      '60-69',
      '70-79',
      '80-89',
      '90-99',
      trans.casesByAge.unk[this.props.lang],
    ],
    ready: false,
    series: [{}],
    options: {},
    selectedViewMode: viewModes.graph,
  };

  toggle = (name) => {
    ApexCharts.exec('casesByAge', 'toggleSeries', name);
  };

  componentDidMount() {
    this.init();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.lang !== this.props.lang) {
      this.init();
    }
  }

  onViewModeChange = (viewMode) => {
    this.setState({
      selectedViewMode: viewMode,
    });
  };

  init() {
    var cD = Object.values(ReducedData.dataAges);
    const reso = cD.map((item) => {
      return item[dict.resolved];
    });

    const active = cD.map((item) => {
      return item[dict.NotResolved];
    });

    const fatal = cD.map((item) => {
      return item[dict.deaths];
    });
    const total = [];

    for (let i = 0; i < fatal.length; i++) {
      total[i] = reso[i] + active[i] + fatal[i];
    }

    this.initGraph(cD, reso, active, fatal, total);
    this.initPie(cD, reso, active, fatal, total);
  }

  initGraph(cD, reso, active, fatal, total) {
    const lang = this.props.lang;
    const ageCategories = this.state.ageCategories;
    this.setState({
      ready: true,
      series: [
        {
          name: trans.casesByAge.active[this.props.lang],
          data: active,
        },
        {
          name: trans.casesByAge.resolved[this.props.lang],
          data: reso,
        },
        {
          name: trans.casesByAge.fatal[this.props.lang],
          data: fatal,
        },
      ],
      stackOptions: {
        legend: {
          show: false,
        },
        tooltip: {
          followCursor: true,
          style: { ...labelStyle },

          custom: function ({
            series,
            seriesIndex,
            dataPointIndex,
            w,
          }) {
            let toolTipData = [
              {
                label: trans.casesByAge.active[lang],
                value: series[0][dataPointIndex].toLocaleString(),
                colour: colours[0],
              },
              {
                label: trans.casesByAge.resolved[lang],
                value: series[1][dataPointIndex].toLocaleString(),
                colour: colours[1],
              },
              {
                label: trans.casesByAge.fatal[lang],
                value: series[2][dataPointIndex].toLocaleString(),
                colour: colours[2],
              },
            ];
            const tooltipTitle = () => {
              if (dataPointIndex === 0) {
                return trans.casesByAge.under20[lang];
              }
              if (dataPointIndex === 9) {
                return (
                  trans.casesByAge.age[lang] +
                  ' ' +
                  trans.casesByAge.unk[lang]
                );
              }
              return `${trans.casesByAge.age[lang]} ${ageCategories[dataPointIndex]}`;
            };
            if (w.globals.collapsedSeriesIndices.length === 1) {
              if (w.globals.collapsedSeriesIndices[0] === 0) {
                toolTipData.shift();
              } else if (w.globals.collapsedSeriesIndices[0] === 1) {
                toolTipData.splice(1, 1);
              } else if (w.globals.collapsedSeriesIndices[0]) {
                toolTipData.pop();
              }
            } else if (
              w.globals.collapsedSeriesIndices.length === 2
            ) {
              if (
                w.globals.collapsedSeriesIndices.includes(0) &&
                w.globals.collapsedSeriesIndices.includes(1)
              ) {
                toolTipData.shift();
                toolTipData.shift();
              } else if (
                w.globals.collapsedSeriesIndices.includes(0) &&
                w.globals.collapsedSeriesIndices.includes(2)
              ) {
                toolTipData.shift();
                toolTipData.pop();
              } else if (
                w.globals.collapsedSeriesIndices.includes(1) &&
                w.globals.collapsedSeriesIndices.includes(2)
              ) {
                toolTipData.pop();
                toolTipData.pop();
              }
            }

            return renderToString(
              ToolTipClone(tooltipTitle(), toolTipData),
            );
          },
        },
        responsive: responsiveFun().map((item) => {
          item.options.yaxis.title.text = trans.age[this.props.lang];
          item.options.chart.height = '350px';
          if (item.options.dataLabels)
            item.options.dataLabels.enabled = true;
          return item;
        }),
        chart: {
          animations: {
            enabled: false,
            animateGradually: {
              enabled: false,
            },
            dynamicAnimation: {
              enabled: false,
            },
          },
          id: 'casesByAge',
          height: 650,
          width: '100%',
          type: 'bar',
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: DownloadButton(
                this.props.lang,
                this.props.chartTitle,
              ),
              selection: false,
              zoom: true,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
        },
        //title: { text: "Breakdown by Age and Sex" },
        dataLabels: {
          enabled: true,
          textAnchor: 'start',
          offsetX: 20,
          style: { ...labelStyle },
          formatter: function (
            value,
            { seriesIndex, dataPointIndex, w },
          ) {
            let indices = w.config.series.map((item, i) => i);
            indices = indices.filter(
              (i) =>
                !w.globals.collapsedSeriesIndices.includes(i) &&
                w.config.series[i].data[dataPointIndex] > 0,
            );
            if (seriesIndex === indices[indices.length - 1]) {
              return lang === 'fr'
                ? w.globals.stackedSeriesTotals[
                    dataPointIndex
                  ].toLocaleString()
                : w.globals.stackedSeriesTotals[dataPointIndex]
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
            return '';
          },
        },
        colors: colours,
        plotOptions: {
          bar: {
            horizontal: true,
            dataLabels: {
              position: 'top',
            },
          },
        },
        stroke: {
          width: 2,
          colors: ['#fff'],
        },
        yaxis: {
          title: {
            text: trans.age[this.props.lang],
          },
          labels: {
            style: { ...labelStyle },
          },
        },
        xaxis: {
          title: {
            offsetY: 20,
            text: trans.casesTotal.yaxis[this.props.lang],
          },
          categories: this.state.ageCategories,
          labels: {
            ...lgXaxisLabels,
            formatter: (value) =>
              this.props.lang === 'fr'
                ? value.toLocaleString()
                : value
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
          },
        },
      },
    });
  }

  initPie(cD, reso, active, fatal, total) {
    this.setState({
      ready: true,
      pieData: total,
      pieOptions: {
        plotOptions: {
          pie: {
            customScale: 0.6,
            expandOnClick: false,
            dataLabels: {
              offset: 80,
              minAngleToShowLabel: 10,
            },
          },
        },
        labels: this.state.ageCategories,
        colors: [
          '#00b0da',
          '#00b29c',
          '#00b454',
          '#84b449',
          '#ebb14a',
          '#ff9f49',
          '#ff8146',
          '#ff6947',
          '#ff6947',
          '#ff6947',
        ],
        dataLabels: {
          dropShadow: {
            enabled: false,
          },
          style: {
            fontSize: '20px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'normal',
            colors: ['black'],
          },
          formatter(val, opts) {
            const name = opts.w.globals.labels[opts.seriesIndex];
            return [name, val.toFixed(1) + '%'];
          },
        },
        legend: {
          show: false,
          labels: {
            useSeriesColors: false,
          },
        },
      },
    });
  }

  render() {
    const GetRightView = () => {
      switch (this.state.selectedViewMode) {
        case viewModes.graph:
          return (
            <>
              <LegandCheckbox
                series={this.state.series}
                colours={colours}
                toggle={this.toggle}
              />
              <ReactApexChart
                options={this.state.stackOptions}
                series={this.state.series}
                type="bar"
                height="600px"
                aria-hidden="true"
              />
            </>
          );
        case viewModes.table:
          return <CasesByAgeTable lang={this.props.lang} />;
        case viewModes.pie:
          return (
            <ReactApexChart
              options={this.state.pieOptions}
              series={this.state.pieData}
              type="pie"
              height="400px"
              aria-hidden="true"
            />
          );
        default:
      }
    };

    return (
      <div id="">
        {this.state.ready && (
          <>
            <ButtonGroup
              selected={this.state.selectedViewMode}
              viewModes={viewModes}
              lang={this.props.lang}
              handleOnClick={this.onViewModeChange}
            />
            <GetRightView />
          </>
        )}
      </div>
    );
  }
}
export default AgeBreak;
